import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import { FhtLeancloudCustomMessageType } from "@/common/types";
import { FHTMessageType } from "@/models/MessageTypes";
import { assert } from "@/common/assert";
export function formatChatStatus(attr, myself) {
  assert(myself, "myself falsy");
  assert(myself.clientId, "clientId falsy!");
  var myUserId = myself.userId;

  if (myUserId && attr.Custom && attr.Custom.length) {
    var found = attr.Custom.find(function (c) {
      return c.UserIds.includes(myUserId);
    });

    if (found) {
      return found.ContentParts.map(function (p) {
        return p.Text;
      }).join("");
    }
  }

  if (attr.Other && attr.Other.length) {
    return attr.Other.map(function (p) {
      return p.Text;
    }).join("");
  }

  console.log("that attr", attr, "myUserId", myUserId);
  throw new Error("weird chat status attr, empty custom & other, see console");
}
export function shouldMessageBeVisible(m, myself) {
  var cm = m; //filter empty status messages

  if (cm.messageType === FHTMessageType.RichCustomMessage && cm.customType === FhtLeancloudCustomMessageType.ChatRoomStatus) {
    var mm = cm;
    assert(mm.customAttrs, "m.body falsy");
    var status = formatChatStatus(mm.customAttrs, myself);
    if (!status) return false;
  } //filter 99 messages


  if (cm.messageType === FHTMessageType.RichCustomMessage && cm.customType === FhtLeancloudCustomMessageType.DataSync) {
    return false;
  }

  return true; //normal message
}
export function isStatusMessage(m) {
  var cm = m;

  if (cm.messageType === FHTMessageType.RichCustomMessage && cm.customType === FhtLeancloudCustomMessageType.ChatRoomStatus) {
    return true;
  }

  return false; //normal message
}